import { atom } from "recoil";

/**
 * PWA 설치 안내 배너의 실측 높이(px). 배너가 없으면 0.
 *
 * 레이아웃 쪽은 배너가 직접 쓰는 CSS 변수(--pwa-banner-height)로 해결되지만,
 * 채널톡 런처는 top/left를 px로 계산해서 CSS 변수로 풀 수 없다. 그쪽만 이 atom을 쓴다.
 */
export const pwaBannerHeightState = atom<number>({
  key: "PwaBannerHeight",
  default: 0,
});
